// extracted by mini-css-extract-plugin
module.exports = {"containerSalauno":"RoutesStyles_containerSalauno__N9Zf5"};